import React, {useState} from 'react'
import { FormHelperText, Box ,TextField,Grid} from "@material-ui/core";
import {MuiSelect} from '../../../componentes/MUI/MuiSelect'
import {useAlumno} from '../../../Context/alumnoContext'
import REG_EX from '../../../Helpers/regex'
 
export const UbicacionInicial = ({objetoModificacion,
                                    provincias,
                                    partidos,
                                    paso_cumplido,
                                    validacion,
                                    validar})=>{
    
    //objetoModificacion es {obj,set}

    const [cargando,setCargando] = useState(true);
    const [id_partido,setIdPartido]=useState(objetoModificacion?.obj?.partido?.id || null)
    const [id_provincia,set_id_provincia] = useState(objetoModificacion?.obj?.provincia?.id || null);
    const [partidos_aux,setPartidos_aux]=useState([])
    const {snackbar} = useAlumno();
    const [avisar,setAvisar] =useState({});

    React.useEffect(()=>{
        if(provincias.length>0 && partidos.length>0){
            setCargando(false)
        }
    },[provincias,partidos])

    React.useEffect(()=>{

        if(Number(id_provincia)>0 && partidos.length>0){
            const seleccion = provincias.filter(item=>item.id==id_provincia)
            objetoModificacion.set({...objetoModificacion.obj,
                provincia:{id:seleccion[0].id,nombre:seleccion[0].nombre},
                partido:null,
                //id_region:null, // región y distrito son de la iglesia y vienen del tramite de patrocinio
                //distrito:null
            })

            setPartidos_aux(partidos.filter(i=>i.id_provincia==id_provincia).map(j=>{
                return {id:j.id_partido,nombre:j.partido}
            }))
        }

    },[id_provincia])

    React.useEffect(()=>{
        if(id_partido && partidos.length>0){
            const seleccion = partidos.filter(item=>item.id_partido==id_partido)

            if(seleccion.length>0){
                objetoModificacion.set({...objetoModificacion.obj,
                                        provincia:{id:seleccion[0].id_provincia,nombre:seleccion[0].provincia},
                                        partido:{id:seleccion[0].id_partido,nombre:seleccion[0].partido},
                                       // id_region:seleccion[0].id_region, // región y distrito son de la iglesia y vienen del tramite de patrocinio
                                       // distrito:{id:seleccion[0].id_distrito,nombre:`Distrito ${seleccion[0].id_distrito}`},
                                        })
            }else{
                snackbar.showMessage('No se pudo determinar la región y distrito para la provincia y partido seleccionados','error')
            }
        }
    },[id_partido])

    const handleChange = (e,regex)=>{

        if(e.target.value === '' || ((regex && regex?.test(e.target.value)|| !regex))){
            const obj_aux = {...objetoModificacion.obj}
            obj_aux[e.target.name]=e.target.value;
    
          /*  objetoModificacion.set({...objetoModificacion.obj,
               localidad:e.target.value.toUpperCase(),
            })
           */
            objetoModificacion.set({...obj_aux})
        }
    }
    
    const changeOnblur = (e)=>{
        if(!e.target.value){
            const aux = {...avisar};
            aux[e.target.name] = true
            setAvisar(aux)
        }else{
            const aux = {...avisar};
            aux[e.target.name] = false
            setAvisar(aux)
        }
    }    

    const checkvalidacion = (campo,validacion)=>{
        const objetoValidacion = validacion(validar)
        const resultado = objetoValidacion[0];
        const texto = objetoValidacion[1]
        const campos = objetoValidacion[2]
    
        if(resultado==true || !(campos instanceof Array) || campos.length==0){
            return ''
        }
        if(campos.some(item=>item.campo==campo)){
            return campos.filter(item=>item.campo==campo)[0]?.texto || ''
        }else{
            return ''
        }
    }

if(cargando){
    return <p>Cargando datos</p>
}   

if(objetoModificacion?.partido?.id>0){
    return <h1>{objetoModificacion?.partido?.nombre}</h1>
}

return <Box sx={{marginTop:'20px'}}>
        <h3 className='text-xl font-medium text-gray-800 mb-1'>Información de su domicilio</h3>

        <Grid container>
            <Grid item xs={12}>
                <div className='form-card'><div>Direccion:<span className='c-obl'></span></div>
                    <TextField 
                            onBlur={changeOnblur} 
                            fullWidth={true} 
                            type='text' 
                            id='ub-direccion'
                            name='direccion'
                            inputProps={{
                                maxLength:500
                            }}
                            value={objetoModificacion.obj?.direccion || ''} 
                            placeholder='Tu respuesta' 
                            onChange={(e)=>{
                                handleChange(e,REG_EX.ADDRESS)
                            }}
                    />
                    <FormHelperText className="Mui-error">{checkvalidacion('direccion',validacion)}</FormHelperText>
               </div>
            </Grid>
        </Grid>
        <Grid container>
            <Grid item xs={12}>
                <div className='form-card'><div>Localidad:<span className='c-obl'></span></div>
                    <TextField 
                                onBlur={changeOnblur} 
                                fullWidth={true} 
                                type='text' 
                                id='ub-localidad'
                                name='localidad'
                                inputProps={{
                                    maxLength:500
                                }}
                                value={objetoModificacion.obj?.localidad || ''} 
                                placeholder='Tu respuesta' 
                                onChange={(e)=>{
                                    handleChange(e,REG_EX.ADDRESS)
                                }}
                        />
                        <FormHelperText className="Mui-error">{checkvalidacion('localidad',validacion)}</FormHelperText>
                    </div>
            </Grid>
            <Grid item xs={12}>
                <div className='form-card'><div>Barrio:</div>
                    <TextField 
                                onBlur={changeOnblur} 
                                fullWidth={true} 
                                type='text' 
                                id='ub-barrio'
                                name='barrio'
                                value={objetoModificacion.obj?.barrio || ''} 
                                placeholder='Tu respuesta' 
                                inputProps={{
                                    maxLength:500
                                }}
                                onChange={(e)=>{
                                    handleChange(e,REG_EX.ADDRESS)
                                }}
                        />
                </div>
            </Grid>
        </Grid>
        <Grid container>
            <Grid item xs={6}>

            </Grid>
            <Grid item xs={6}>

            </Grid>
        </Grid>
        <div className='form-card'><div>Código postal:<span className='c-obl'></span></div>
                <TextField 
                        onBlur={changeOnblur} 
                        fullWidth={true} 
                        type='text' 
                        id='ub-codpostal'
                        name='cod_postal'
                        inputProps={{
                            maxLength:10
                        }}
                        value={objetoModificacion.obj?.cod_postal || ''} 
                        placeholder='Tu respuesta' 
                        onChange={(e)=>{
                            handleChange(e,REG_EX.NUMERIC)
                        }}
                />
                <FormHelperText className="Mui-error">{checkvalidacion('cod_postal',validacion)}</FormHelperText>

                        <Campos partidos_aux={partidos_aux}
                            provincias={provincias}
                            id_partido={id_partido}
                            setIdPartido={setIdPartido}
                            id_provincia={id_provincia}
                            avisar={avisar}
                            paso_cumplido={paso_cumplido}
                            set_id_provincia={set_id_provincia}
                            objetoModificacion={objetoModificacion}
                            checkvalidacion={checkvalidacion}
                            validacion={validacion}
                        />
        </div>     
</Box>

}

const Campos = ({partidos_aux,provincias,
                id_partido,
                setIdPartido,
                id_provincia,
                set_id_provincia,
                avisar,
                paso_cumplido,
                checkvalidacion,
                validacion,
                objetoModificacion})=>{

    return <Grid container>
                <Grid item xs={12}>
                    <div className='form-card'><div>Provincia:<span className='c-obl'></span></div>
                        <MuiSelect datos={provincias} 
                            value={id_provincia}
                            noDefault
                            tituloDefault={'Seleccione'}
                            // NO PERMITO QUE MODIFIQUE EL EMAIL PORQUE LO COMPLETÓ EL PATROCINANTE
                            disabled={false}
                            setValue= {set_id_provincia}
                            />
                            <FormHelperText className="Mui-error">{checkvalidacion('provincia',validacion)}</FormHelperText>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='form-card'><div>Partido:<span className='c-obl'></span></div>
                        <MuiSelect datos={partidos_aux} 
                                    noDefault
                                    noAdvertir
                                   // NO PERMITO QUE MODIFIQUE EL EMAIL PORQUE LO COMPLETÓ EL PATROCINANTE
                                   setValue= {setIdPartido}
                                   disabled={false}
                                   tituloDefault={'Seleccione'}
                                    value={id_partido}
                            />
                            <FormHelperText className="Mui-error">{checkvalidacion('partido',validacion)}</FormHelperText>
                    </div>
                </Grid>
    </Grid>
}




